import { fetchBudgetDrivers } from '../service/budgetDriversService'
import { BudgetDriver } from '../../../types/budgetDriver/BudgetDriver'
import budgetDriversQueryKeys from './budgetDriversQueryKeys'

export const getBudgetDriversOptions = <TData = BudgetDriver[]>(
  companyId?: string,
  select?: (data: BudgetDriver[]) => TData
) => {
  return {
    queryKey: budgetDriversQueryKeys.list({ companyId }),
    queryFn: fetchBudgetDrivers,
    gcTime: 15 * 60 * 1000, // 15 minutes
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!companyId,
    select: (data: BudgetDriver[]) => {
      // Always sort by order first
      const sortedData = data.slice().sort((a, b) => {
        const orderA = a.order ?? Number.MAX_SAFE_INTEGER
        const orderB = b.order ?? Number.MAX_SAFE_INTEGER
        return orderA - orderB
      })

      // If a selector is provided, run it on the sorted data
      if (select) {
        return select(sortedData)
      }

      // Otherwise return the sorted data
      return sortedData as TData
    }
  }
}
